/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsControllerFindOneQueryResponse,
  TelegramProductsControllerFindOnePathParams,
  TelegramProductsControllerFindOneQueryParams,
  TelegramProductsControllerFindOne401,
} from '../types/TelegramProductsControllerFindOne.ts';

function getTelegramProductsFindOneUrl(link: TelegramProductsControllerFindOnePathParams['link']) {
  const res = { method: 'GET', url: `/api/telegram/products/${link}` as const };
  return res;
}

/**
 * {@link /api/telegram/products/:link}
 */
export async function telegramProductsFindOne(
  link: TelegramProductsControllerFindOnePathParams['link'],
  params?: TelegramProductsControllerFindOneQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsControllerFindOneQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindOne401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsFindOneUrl(link).url.toString(), params, ...requestConfig });
  return res.data;
}
